import { IS_USE_PRODUCTION_ENV } from '@/constants/is-use-production-env';

const StoreConfig = {
  category_url_suffix: '/',
  store_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
  configurable_thumbnail_source: 'itself',
  product_url_suffix: '.html',
  available_countries: [
    {
      code: 'us',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/us.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/us-mobile.png`,
      name: 'United States',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com' : '192.168.0.99:30000',
      currency: 'USD',
      language: 'English',
      hreflang: 'en-us',
      basePath: '',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com' : 'http://192.168.0.99:30000',
    },
    {
      code: 'uk',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/gb.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/gb-mobile.png`,
      name: 'United Kingdom',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.co.uk' : '192.168.0.99:4000',
      currency: 'GBP',
      language: 'English',
      hreflang: 'en-gb',
      basePath: '',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.co.uk' : 'http://192.168.0.99:4000',
    },
    {
      code: 'ca',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ca.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ca-mobile.png`,
      name: 'Canada',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.ca' : '192.168.0.99:5000',
      currency: 'CAD',
      language: 'English',
      hreflang: 'en-ca',
      basePath: '',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.ca' : 'http://192.168.0.99:5000',
    },
    {
      code: 'ca_fr',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ca.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ca-mobile.png`,
      name: 'Canada',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.ca/fr' : '192.168.0.99:5100/fr',
      currency: 'CAD',
      language: 'French',
      hreflang: 'fr-ca',
      hideInOptions: true,
      basePath: '/fr',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.ca/fr' : 'http://192.168.0.99:5100/fr',
    },
    {
      code: 'au',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/au.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/au-mobile.png`,
      name: 'Australia',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com/au' : '192.168.0.99:8000/au',
      currency: 'AUD',
      language: 'English',
      hreflang: 'en-au',
      basePath: '/au',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com/au' : 'http://192.168.0.99:8000/au',
    },
    {
      code: 'de',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/de.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/de-mobile.png`,
      name: 'Germany',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com/de' : '192.168.0.99:7000/de',
      currency: 'EUR',
      language: 'Deutsch',
      hreflang: 'de',
      basePath: '/de',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com/de' : 'http://192.168.0.99:7000/de',
      sharedLanguageSite: true,
      defaultSharedLanguageSite: true,
    },
    {
      code: 'de_en',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/de.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/de-mobile.png`,
      name: 'Germany',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com/de/en' : '192.168.0.99:7100/de/en',
      currency: 'EUR',
      language: 'English',
      hreflang: 'en-de',
      hideInOptions: true,
      basePath: '/de/en',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com/de/en' : 'http://192.168.0.99:7100/de/en',
    },
    {
      code: 'fr',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/fr.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/fr-mobile.png`,
      name: 'France',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com/fr' : '192.168.0.99:8500/fr',
      currency: 'EUR',
      language: 'French',
      hreflang: 'fr',
      basePath: '/fr',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com/fr' : 'http://192.168.0.99:8500/fr',
    },
    {
      code: 'ie',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ie.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ie-mobile.png`,
      name: 'Ireland',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/ie` : '192.168.0.99:9000/ie',
      currency: 'EUR',
      language: 'English',
      hreflang: 'en-ie',
      basePath: '/ie',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/ie` : 'http://192.168.0.99:9000/ie',
    },
    {
      code: 'it',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/it.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/it-mobile.png`,
      name: 'Italy',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/it` : '192.168.0.99:9100/it',
      currency: 'EUR',
      language: 'Italian',
      hreflang: 'it',
      basePath: '/it',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/it` : 'http://192.168.0.99:9100/it',
    },
    {
      code: 'nz',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/nz.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/nz-mobile.png`,
      name: 'New Zealand',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/nz` : '192.168.0.99:10000/nz',
      currency: 'NZD',
      language: 'English',
      hreflang: 'en-nz',
      basePath: '/nz',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/nz` : 'http://192.168.0.99:10000/nz',
    },
    {
      code: 'es',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/es.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/es-mobile.png',
      name: 'Spain',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/es` : '192.168.0.99:11500/es',
      currency: 'EUR',
      language: 'Spanish',
      hreflang: 'es',
      basePath: '/es',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/es` : 'http://192.168.0.99:11500/es',
      defaultSharedLanguageSite: true,
      sharedLanguageSite: true,
    },
    {
      code: 'se',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/se.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/se-mobile.png',
      name: 'Sweden',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/se` : '192.168.0.99:12000/se',
      currency: 'SEK',
      language: 'Swedish',
      hreflang: 'se',
      basePath: '/se',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/se` : 'http://192.168.0.99:12000/se',
    },
    {
      code: 'at',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/at.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/at-mobile.png',
      name: 'Austria',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/de` : '192.168.0.99:7000/de',
      currency: 'EUR',
      language: 'Deutsch',
      hreflang: 'de',
      basePath: '/de',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/de` : 'http://192.168.0.99:7000/de',
      sharedLanguageSite: true,
    },
    {
      code: 'be',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/be.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/be-mobile.png',
      name: 'Belgium',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/nl` : '192.168.0.99:10500/nl',
      currency: 'EUR',
      language: 'Dutch',
      hreflang: 'nl',
      basePath: '/nl',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/nl` : 'http://192.168.0.99:10500/nl',
      sharedLanguageSite: true,
    },
    {
      code: 'nl',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/nl.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/nl-mobile.png',
      name: 'Netherlands	',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/nl` : '192.168.0.99:10500/nl',
      currency: 'EUR',
      language: 'Dutch',
      hreflang: 'nl',
      basePath: '/nl',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/nl` : 'http://192.168.0.99:10500/nl',
      sharedLanguageSite: true,
      defaultSharedLanguageSite: true,
    },
    {
      code: 'ch',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/ch.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/ch-mobile.png',
      name: 'Switzerland',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/de` : '192.168.0.99:7000/de',
      currency: 'CHF',
      language: 'Deutsch',
      hreflang: 'de',
      basePath: '/de',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/de` : 'http://192.168.0.99:7000/de',
      sharedLanguageSite: true,
    },
    {
      code: 'sg',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/sg.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/sg-mobile.png',
      name: 'Singapore',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/sg` : '192.168.0.99:11000/sg',
      currency: 'SGD',
      language: 'English',
      hreflang: 'en-sg',
      basePath: '/sg',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/sg` : 'http://192.168.0.99:11000/sg',
    },
    {
      code: 'mx',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/mx.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/mx-mobile.png',
      name: 'Mexico',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/es` : '192.168.0.99:11500/es',
      currency: 'MXN',
      language: 'Spanish',
      hreflang: 'es',
      basePath: '/es',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/es` : 'http://192.168.0.99:11500/es',
      sharedLanguageSite: true,
    },
  ],
  // 修改地址时使用
  default_country_code: process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE,
  // 跳转多语言网站时使用
  current_country_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
  currency: {
    current_currency_code: process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
    default_display_currency_code: process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
    available_currency_codes: ['AUD', 'GBP', 'CAD', 'USD', 'NZD', 'SGD', 'MXN'],
  },
};

export default StoreConfig;
